'use client';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const DROP_ICON = $icon('arrow-bar-to-down');
export const INVALID_DROP_ICON = $icon('alert-triangle');
//# sourceMappingURL=FileDropOverlay.js.map